<template>
  <div
    v-if="content"
    class="text-[#2B2926] font-normal"
    :class="textClasses"
    :data-blok-c="dataBlokC"
    :data-blok-uid="dataBlokUid"
  >
    <div
      v-if="isHtml"
      class="rich-text-content"
      @click="handleRichTextClick"
      v-html="content"
    ></div>
    <p v-else class="mb-0 whitespace-pre-wrap break-words">{{ content }}</p>
  </div>
</template>

<script>
import { handleChurchUpdateRichTextLinkClick } from '@/utils/church-update-links';

export default {
  name: 'ContentText',
  props: {
    content: {
      type: String,
      default: '',
    },
    isHtml: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'medium',
      validator: value => ['small', 'medium', 'large'].includes(value),
    },
    dataBlokC: {
      type: String,
      default: '',
    },
    dataBlokUid: {
      type: String,
      default: '',
    },
  },
  computed: {
    textClasses() {
      const sizeMap = {
        small: 'text-[0.875rem] leading-[1.25rem]',
        medium: 'text-[1rem] leading-[1.5rem]',
        large: 'text-[1.125rem] leading-[1.75rem]',
      };
      return sizeMap[this.size] || sizeMap.medium;
    },
  },
  methods: {
    handleRichTextClick(event) {
      return handleChurchUpdateRichTextLinkClick(event, { router: this.$router });
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Inter', 'aktiv-grotesk', sans-serif;
}

.rich-text-content :deep(p) {
  display: block;
  margin-bottom: 1em;
  margin-top: 0;
  line-height: inherit;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: none;
}

.rich-text-content :deep(p:first-child),
.rich-text-content :deep(p + p) {
  margin-top: 0;
}

.rich-text-content :deep(p:last-child) {
  margin-bottom: 0;
}

.rich-text-content :deep(br) {
  display: block;
  margin-top: 0.5em;
  content: '';
  line-height: 1.5;
}

.rich-text-content :deep(ul) {
  list-style-type: disc;
  padding-left: 1.25rem;
  margin: 0.75rem 0;
}

.rich-text-content :deep(ol) {
  list-style-type: decimal;
  padding-left: 1.25rem;
  margin: 0.75rem 0;
}

.rich-text-content :deep(li) {
  display: list-item;
  margin: 0.25rem 0;
}

.rich-text-content :deep(ul ul) {
  list-style-type: circle;
  margin: 0;
}

.rich-text-content :deep(ul ul ul) {
  list-style-type: square;
  margin: 0;
}

.rich-text-content :deep(li > p) {
  margin: 0;
}
</style>
